/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown logging in a mockuser failed
 * @export
 * @class AuthCouldNotLoginMockUserError
 * @extends {Error}
 */
export class AuthCouldNotLoginMockUserError extends Error {
  /**
   * Creates an instance of AuthCouldNotLoginMockUserError
   * @param {string} message The Error `message`
   * @memberof AuthCouldNotLoginMockUserError
   */
  constructor(message) {
    super(message);
    this.name = `AuthCouldNotLoginMockUserError`;
  }
}

/**
 * Called logging in a mockuser failed
 * @returns {never} never
 */
const throwAuthCouldNotLoginMockUserError = () => {
  throw new AuthCouldNotLoginMockUserError(
    stripIndent(`
    Could not login. No "__mockUser" has been set or is "__mockUser" is "null" or a login was attemped not matching details in "__mockUser"
    Have you called "__setMockUser(userFixture)"?
    `),
  );
};

export default throwAuthCouldNotLoginMockUserError;
